module.exports = __webpack_public_path__ + "img/nation.8312b51c.svg";